<template>
  <v-menu
    v-if="$puedo('admin_notificaciones:lectura') && 1===2"
    offset-y
    left
    origin="right top"
    z-index="99"
    content-class="notification-dropdown"
    nudge-top="-10"
  >

    <v-btn
      class="notification-icon ma-0"
      icon
      large
      slot="activator"
      v-if="$puedo('admin_notificaciones:lectura') && 1==2"
    >
      <i
        v-if="notificaciones.length > 0"
        class="zmdi white--text zmdi-notifications-active animated infinite wobble zmdi-hc-fw font-lg"
      ></i>
      <i
        v-else
        class="zmdi white--text zmdi-notifications-active zmdi-hc-fw font-lg"
      ></i>
    </v-btn>
    <div class="dropdown-content">
      <div class="dropdown-top d-custom-flex justify-space-between primary">
        <span class="white--text fw-bold">Notificaciones</span>
        <span class="v-badge warning">{{total}} NUEVAS</span>
      </div>
      <v-list class="dropdown-list">
        <v-list-tile
          v-for="notificacion in notificaciones"
          :key="notificacion.id"
        >
          <i class="mr-3 zmdi zmdi-email seondary--text"></i>
          <span v-html="sinHtmlTag(notificacion.notificacion)"></span>
        </v-list-tile>
      </v-list>
      <div
        class="dropdown-top justify-center align-center d-custom-flex primary"
        style="cursor: pointer"
      >
        <span
          class="v-badge warning"
          @click="verNotificaciones"
        >Ver todas</span>

      </div>
    </div>
  </v-menu>
</template>

<script>

export default {
  data () {
    return {
      notificaciones: [],
      total: 0
    }
  },
  computed: {
    usuario () {
      return this.$store.getters.getUser
    },
    tieneNotificacion () {
      return this.notificaciones.length
    }

  },
  methods: {
    obtenerNotificaciones: function () {
      if (this.usuario !== null) {
        let usuarioId = this.usuario.id

        this.$store.dispatch('notificaciones/obtenerNotificacionesNuevas', { id: usuarioId }).then(response => {
          this.notificaciones = response.data
          this.total = response.total
        })
      }
    },
    verNotificaciones: function () {
      this.$router.push({ name: 'notificaciones' })
    },
    sinHtmlTag (notificacion) {
      let regex = /(<([^>]+)>)/ig
      return notificacion.replace(regex, '')
    }
  },
  mounted () {
    this.obtenerNotificaciones()

    setInterval(function () {
      this.obtenerNotificaciones()
    }.bind(this), 60000)
  }
}
</script>
<style>
.notificacion {
  font-size: 0.85rem !important;
}
.contenedor-notificacion > .v-list__tile {
  height: 56px !important;
  padding: 0 6px !important;
}
</style>
